import React from 'react';

import type { StatsStat } from '../../../../mock-data/types';
import { LiveNumber } from '../LiveNumber';
import { Root, Label, Value } from './SplitStat.styles';

export type SplitStatProps = {
  data: StatsStat;
  /** While true, the figure shows a placeholder (the endpoint is loading). */
  loading?: boolean;
};

/** A bare label + live figure pair — the split stats (Stakes / Wins, Withdrawals
 *  / Player Balance, …) sitting under a card's lead figure. The label is static
 *  chrome; only the figure loads in. */
export const SplitStat = ({ data, loading = false }: SplitStatProps): React.ReactElement => (
  <Root>
    <Label text={data.label} tag="span" />
    <Value>
      <LiveNumber
        value={data.value}
        prefix={data.prefix}
        suffix={data.suffix}
        decimals={data.decimals}
        loading={loading}
        missing={data.missing}
        error={data.error}
        indeterminate={data.indeterminate}
      />
    </Value>
  </Root>
);

export default SplitStat;
